import { styled, Box, Chip, chipClasses } from '@mui/material';

export const ListFieldChipEmptyContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(2),
  gap: theme.spacing(2),
  textAlign: 'center',
  width: '100%',
  borderRadius: 10,
  backgroundColor: '#FAFBFD',
  border: `1px dashed ${theme.palette.divider}`,
}));

export const ListFieldChipItemChip = styled(Chip)(({ theme }) => ({
  borderRadius: 24,

  [`&.${chipClasses.clickable}`]: {
    borderStyle: 'dashed',
    fontWeight: theme.typography.fontWeightMedium,
  },

  [`& .${chipClasses.deleteIcon}`]: {
    fontSize: theme.typography.pxToRem(18),
  },
}));
